import React from "react"
import { Portal } from "react-portal"

type PortalMountProps = React.PropsWithChildren<{
  containerId: string
  className?: string
}>

const PortalMount = ({ containerId, children, className = "h-full" }: PortalMountProps) => {
  const portalNodeRef = React.useRef<HTMLDivElement | null>(null)

  if (!portalNodeRef.current && typeof document !== "undefined") {
    portalNodeRef.current = document.createElement("div")
  }

  React.useLayoutEffect(() => {
    const host = document.getElementById(containerId)
    const portalNode = portalNodeRef.current

    if (!host || !portalNode) {
      return
    }

    portalNode.className = className
    portalNode.dataset.portalContainerId = containerId

    if (host.firstChild !== portalNode || host.childNodes.length !== 1) {
      host.replaceChildren(portalNode)
    }
  })

  React.useEffect(() => {
    const portalNode = portalNodeRef.current

    return () => {
      portalNode?.remove()
    }
  }, [])

  if (!portalNodeRef.current) {
    return null
  }

  return <Portal node={portalNodeRef.current}>{children}</Portal>
}

export default PortalMount
